import { render, staticRenderFns } from "./DeleteRecord.vue?vue&type=template&id=4a0e93bb"
import script from "./DeleteRecord.vue?vue&type=script&lang=js"
export * from "./DeleteRecord.vue?vue&type=script&lang=js"
import style0 from "./DeleteRecord.vue?vue&type=style&index=0&id=4a0e93bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports